<template>
  <!--确认扣罚弹框-->
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('base.penaltyReconciliationStatement')"
    :visible.sync="isShowDeduction"
    top="5vh"
    width="660px"
  >
    <div>
      <!--   表头   -->
      <div class="flex-start">
        <img alt="logo" src="@/assets/ajlogo1.svg" style="width: 100px; margin-right: 20px">
        <span style="font-size: 20px; font-weight: bold; color: black">{{
          $t('base.anJunLMPenaltyStatement')
        }}</span>
      </div>
      <!--   基础信息   -->
      <div style="margin: 10px 0; font-size: 16px; font-weight: bold">
        {{ $t('newOrder.BasicInformation') }}
      </div>
      <div>
        <div class="info-table">
          <div class="info-row">
            <div class="info-label">{{ $t('navbar.siteName') }}</div>
            <div class="info-value">{{ resultData.siteName || '--' }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ $t('base.entityName') }}</div>
            <div class="info-value">{{ resultData.providerBody || '--' }}</div>
          </div>
          <div class="info-row">
            <div class="info-label">{{ $t('base.billingMonth') }}</div>
            <div class="info-value">{{ resultData.billPeriod || '--' }}</div>
          </div>
        </div>
      </div>
      <!--  扣款明细   -->
      <div style="margin: 10px 0; font-size: 16px; font-weight: bold">
        {{ $t('base.deductionDetails') }}
      </div>
      <!-- 原生标准 table -->
      <table class="deduction-table">
        <thead>
          <tr>
            <th>{{ $t('base.deductionItem') }}</th>
            <th>{{ $t('mdfeTranslate.quantity') }}</th>
            <th>{{ $t('base.totalDeductionAmount') }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- 1. 循环渲染后端返回的 details -->
          <tr v-for="(item, index) in resultData.details" :key="index">
            <td>{{ item.responsibilityTypeStr }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.amountStr }}</td>
          </tr>
          <!-- 关键：插入跨3列的空白行 -->
          <tr class="empty-row" style="height: 35px !important">
            <td colspan="3" />
          </tr>
          <!-- 总计行 -->
          <tr class="total-row">
            <td>{{ $t('newOrder.Total') }}</td>
            <td>{{ resultData.totalQuantity }}</td>
            <td>{{ resultData.totalAmountStr }}</td>
          </tr>
        </tbody>
      </table>

      <!-- 底部提示语 -->
      <div class="tip">
        <span class="icon">!</span>
        {{ $t('base.deadlineNotice1') }} {{ resultData.confirmDeadline }}，{{
          $t('base.deadlineNotice2')
        }}
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="rowData.btn === 1"
        size="small"
        type="primary"
        @click="btnConfirmPenaltyBill"
      >
        {{ $t('base.approved') }}
      </el-button>
      <el-button size="small" @click="isShowDeduction = false">
        {{ $t('GlobalSetObj.Close') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { lmPenaltyBillAudit, lmPenaltyBillInfo } from '@/api/definiteResponsibilityAndPenalty';

export default {
  name: 'Details',
  data() {
    return {
      isShowDeduction: false,
      resultData: {},
      rowData: {}
    };
  },
  methods: {
    // 确认扣罚
    async btnConfirmPenaltyBill() {
      this.$confirm(this.$t('scripting.confirmAuditPass'), this.$t('operationCenter.tips'), {
        confirmButtonText: this.$t('customerManagements.confirm'), // '确定',
        cancelButtonText: this.$t('customerManagements.cancel'), // '取消',
        type: 'warning'
      }).then(async() => {
        const data = {
          idList: [this.rowData.id]
        };
        const res = await lmPenaltyBillAudit(data);
        if (res.code === 200) {
          this.isShowDeduction = false;
          console.log(res, 'res');
          if (res.data && res.data.failCount > 0) {
            this.$message.error(res.data.failReasonList[0]);
          }
          if (res.data && res.data.failCount === 0) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
          }
          this.$emit('call-parent-search');
        }
      });
    },

    // 打开弹框
    async showDeductionDialog(data) {
      console.log(data, 'showDeductionDialog');
      this.rowData = data;
      const res = await lmPenaltyBillInfo(data.id);
      this.resultData = res.data;
      this.isShowDeduction = true;
    }
  }
};
</script>

<style scoped>
.info-table {
  border: 1px solid #b4b4b4;
}

.info-row {
  display: flex;
  border-bottom: 1px solid #b4b4b4;
}

/* 去掉最后一行的下边框 */
.info-row:last-child {
  border-bottom: none;
}

.info-label {
  width: 180px; /* 标签列宽度 */
  padding: 5px 8px;
  border-right: 1px solid #b4b4b4;
  font-size: 16px;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-value {
  flex: 1;
  padding: 5px 8px;
  font-size: 16px;
  color: #303133;
  display: flex;
  align-items: center;
}

/* 表格：现代CSS标准写法 替代 废弃属性 */
.deduction-table {
  width: 100%;
  /* 合并边框（替代 cellspacing） */
  border-collapse: collapse;
  /* 文字居中 */
  text-align: center;
  font-size: 14px;
}

/* 表头 + 单元格 */
.deduction-table th,
.deduction-table td {
  /* 边框（替代 border=1） */
  border: 1px solid #dcdcdc;
  /* 内边距（替代 cellpadding） */
  padding: 8px;
}

/* 表头样式 */
.deduction-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

/* 总计行高亮 */
.total-row {
  background-color: #f2f2f2;
  font-weight: bold;
}

/* 提示语 */
.tip {
  margin-top: 12px;
  color: #f57f17;
  display: flex;
  align-items: center;
  font-size: 13px;
}

/* 感叹号图标 */
.icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: #f57f17;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 16px;
  font-size: 12px;
  margin-right: 6px;
}

.empty-row td {
  padding: 8px;
  height: 20px !important;
  line-height: 20px;
}
</style>
